import { useTranslation } from 'react-i18next';
import Skeleton from '@mui/material/Skeleton';

import { Help } from 'src/components/Icon';
import { useClientVerification } from 'src/features/login/hooks/useClientVerification';
import { useExistingSession } from 'src/features/login/hooks/useExistingSession';

import ClientLogo from '../components/ClientLogo';
import LoginForm from '../components/LoginForm';
import {
  Info,
  Background,
  LoginBox,
  Title,
  LoginDescription,
  TextButton,
  InfoContainer,
  Form,
} from '../styled';

const Login = () => {
  const { t } = useTranslation(['login']);
  const { client, csrfCode, isLoading, isSuccess, refreshCsrfCode } = useClientVerification();
  useExistingSession({ enabled: isSuccess });

  const hasClientLogo = Boolean(client?.logo);
  const clientHomeUri = client?.homeUri;

  return (
    <Background>
      <LoginBox>
        <Title>{hasClientLogo ? t('login:pitta_account_verification') : t('login:login')}</Title>
        {client?.title && clientHomeUri && (
          <LoginDescription>
            <span style={{ marginRight: '4px' }}>{t('login:sign_in_with_pitta_account')}</span>
            <TextButton
              type="button"
              onClick={() => {
                window.open(clientHomeUri, '_blank', 'noopener,noreferrer');
              }}
            >
              {client.title}
            </TextButton>
          </LoginDescription>
        )}
        <ClientLogo client={client} />
        {isLoading && (
          <Form aria-busy="true" aria-label="loading">
            <Skeleton variant="rectangular" height={48} sx={{ borderRadius: 1, marginTop: 2 }} />
            <Skeleton variant="rectangular" height={48} sx={{ borderRadius: 1, marginTop: 2 }} />
            <Skeleton variant="rectangular" height={52} sx={{ borderRadius: 1, marginTop: 3 }} />
            <Skeleton variant="text" width={120} sx={{ marginTop: 2 }} />
          </Form>
        )}
        {isSuccess && <LoginForm csrfCode={csrfCode} refreshCsrfCode={refreshCsrfCode} />}
        <InfoContainer>
          <Info>
            <Help />
            {t('login:contact_the_person')}
          </Info>
        </InfoContainer>
      </LoginBox>
    </Background>
  );
};

export default Login;
